<template>
  <div class="d-flex align-items-center">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-lg-12 col-8 font-size">
      <router-link
        v-if="row[idKey] && data !== linkInactiveCondition?.condition"
        class="badge badge-success"
        :to="{
          name: linkRouteName,
          query: setQuery(),
        }"
        >{{ data }}</router-link
      >
      <span v-else class="badge badge-success">{{ data }}</span>
    </div>
  </div>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";

export default {
  name: "SortTableRouterTypeComponent",
  components: { SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    linkRouteName: {
      type: String,
      required: true,
    },
    idKey: {
      default: 0,
      type: Number,
      required: false,
    },
    linkInactiveCondition: {
      type: Object,
      required: false,
      default: () => {},
    },
    queryName: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    data() {
      return this.row[this.column.index ? this.column.index : this.column.name];
    },
  },
  methods: {
    setQuery() {
      const state = {};
      state[this.queryName] = this.row[this.idKey];
      return state;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  &.badge-success {
    border: 1px solid $green;
    &:hover {
      background-color: $white;
      color: $green;
    }
  }
}
</style>
